var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextAlignLeft18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3h15v2H1V3zM1 8h10v2H1V8zM14 13H1v2h13v-2z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGQ9Ik0xIDNoMTV2MkgxVjN6TTEgOGgxMHYySDFWOHpNMTQgMTNIMXYyaDEzdi0yeiIvPjwvc3ZnPg==";
export { SvgTextAlignLeft18 as ReactComponent };